import Test from "../components/Test";
import AdminLogin from "../pages/admin/auth/Login";
import AdminDashborad from "../layout/adminDashboard/AdminDashborad";
import PendingRequests from "../pages/admin/PendingRequests";
import CollageList from "../pages/admin/CollageList";
import StudentList from "../pages/admin/StudentList";

import AdminAuthWrapper from "../AuthWrapper/AdminAuthWrapper";
import Adminhomepage from "../pages/admin/Adminhomepage";
import PendingReportList from "../components/admin/PendingReportList";
import AttendanceCalendar from "../components/AttendanceCalendar";
import ManageAttendance from "../pages/ManageAttendance";

const adminRoutes = [
    {
        path: '/admin',
        element:<AdminAuthWrapper>
            <AdminDashborad/>
        </AdminAuthWrapper> ,
        children:[
            {
                index: true,
                element: <Adminhomepage />
            },
            {
                path: 'pending-requests',
                element: <PendingRequests />
            },
            {
                path: 'registered-collages',
                element: <CollageList />
            },
            {
                path: 'registered-students',
                element: <StudentList />
            },
            {
                path: 'manage-attendance',
                element: <ManageAttendance/>
              },
              {
                path: 'attendance-calendar',
                element: <AttendanceCalendar/>
              },
            {
                path: 'reports', // ✅ new route for reports
                element: <PendingReportList />
            }
        ]
    },
    {
        path: '/admin/login',
        element: <AdminLogin />
    }
];

export default adminRoutes;
